// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__npm0M","modalContent":"styles_modalContent__Ma7CA","header":"styles_header__D7361"};